import {reactionsStore} from './reactions';
import {sentStore} from './sent';
import {visitsStore} from './visits';

class FeaturesStore {
  reactions = reactionsStore;
  visits = visitsStore;
  sent = sentStore;

  resetAllLists() {
    this.reactions.resetList();
    this.visits.resetList();
    this.sent.resetList();
  }

  resetReactionsAndVisits() {
    this.reactions.resetList();
    this.visits.resetList();
  }
}

export const featuresActivityStore = new FeaturesStore();
